import { ReactElement } from 'react'
import { Route } from 'react-router-dom'
import { pages } from 'navigation/pages'
import Quotation from '../components/Quotation'

export default function QuotationRouter(): ReactElement {
  return <Route path={pages.connected.quotation.root.name} element={<Quotation />} />
}
